module.exports = __webpack_public_path__ + "img/permit.c677e3ed.svg";